import { ConnectionNames } from "../contracts";
import { connectWithToken } from "../common";
import { SDQuerySubscribersStore } from "../c_sportsbook";
export const ConnectWithToken = {
    [ConnectionNames.sports]: connectWithToken.bind(undefined, ConnectionNames.sports, SDQuerySubscribersStore),
};
//# sourceMappingURL=ConnectionWithToken.js.map